var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tree-node" }, [
    _c(
      "div",
      {
        staticClass: "tree-node-content",
        class: {
          selected: _vm.category.id === _vm.selectedId,
          disabled: _vm.isDisabled,
        },
        on: { click: _vm.selectCategory },
      },
      [
        _vm.category.children && _vm.category.children.length
          ? _c(
              "span",
              {
                staticClass: "toggle",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleExpand.apply(null, arguments)
                  },
                },
              },
              [
                _c("b-icon", {
                  attrs: {
                    icon: _vm.isExpanded ? "chevron-down" : "chevron-left",
                    size: "is-small",
                  },
                }),
              ],
              1
            )
          : _c("span", { staticClass: "toggle-spacer" }),
        _c("label", { staticClass: "node-label" }, [
          _c("input", {
            attrs: { type: "radio", disabled: _vm.isDisabled },
            domProps: {
              value: _vm.category.id,
              checked: _vm.category.id === _vm.selectedId,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.selectCategory.apply(null, arguments)
              },
            },
          }),
          _c("span", { staticClass: "node-name" }, [
            _vm._v(_vm._s(_vm.category.name)),
          ]),
        ]),
      ]
    ),
    _vm.isExpanded && _vm.category.children && _vm.category.children.length
      ? _c(
          "div",
          { staticClass: "tree-node-children" },
          _vm._l(_vm.category.children, function (child) {
            return _c("tree-node", {
              key: child.id,
              attrs: {
                category: child,
                "selected-id": _vm.selectedId,
                "disabled-ids": _vm.disabledIds,
              },
              on: {
                select: function ($event) {
                  return _vm.$emit("select", $event)
                },
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }